/**
 * Vendor profile defaults for call camera start state.
 * Nurse default OFF (0); Patient default ON (1) when unset — matches legacy behavior.
 */

const PATIENT_KEY = 'srm_default_video_on_patient';
const NURSE_KEY = 'srm_default_video_on_nurse';

const coerceOnFlag = (value, defaultOn) => {
  if (value === undefined || value === null || value === '') {
    return defaultOn;
  }
  return value === true || value === 1 || value === '1';
};

export const persistVendorDefaultVideoFlags = (vendor = {}) => {
  try {
    localStorage.setItem(
      NURSE_KEY,
      coerceOnFlag(vendor.defaultVideoOnNurse, false) ? '1' : '0'
    );
    localStorage.setItem(
      PATIENT_KEY,
      coerceOnFlag(vendor.defaultVideoOnPatient, true) ? '1' : '0'
    );
  } catch (_e) {
    /* ignore */
  }
};

export const readDefaultVideoOnNurse = () => {
  try {
    const raw = localStorage.getItem(NURSE_KEY);
    if (raw === null) return false;
    return raw === '1';
  } catch (_e) {
    return false;
  }
};

export const readDefaultVideoOnPatient = () => {
  try {
    const raw = localStorage.getItem(PATIENT_KEY);
    if (raw === null) return true;
    return raw === '1';
  } catch (_e) {
    return true;
  }
};

/** @returns {boolean} true when local camera should start muted */
export const resolveInitialLocalVideoMute = (isCustomer) => {
  if (isCustomer) {
    return !readDefaultVideoOnPatient();
  }
  return !readDefaultVideoOnNurse();
};

export default {
  persistVendorDefaultVideoFlags,
  readDefaultVideoOnNurse,
  readDefaultVideoOnPatient,
  resolveInitialLocalVideoMute,
};
